module.exports = __webpack_public_path__ + "media/images/logo-ba89aa02.png";